<div class="sendToSubscriptions w-100 d-flex flex-column">
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="onCancelClicked()">
        <svg class="icon-16"><use href='../../App_Themes/clearview-default/icons/utility/close.svg#close'></use></svg>
    </button>
    <div class="modal-title border-separator-bottom pb-2">
        <h1 class="h6 font-size-20 m-0" cvLocalizedText [langSection]="'Module_Subscriptions'" [langKey]="'Send_To_Subscription_Title'">Send To Subscription</h1>
        <div class="body-2 mt-1">{{ modalData.moduleName }}</div>
    </div>
    <div class="scroll-container d-flex flex-column">
        <div class="mx-auto h-100 subscriptionSchedulerModal align-self-center" style="z-index: auto;"><!--"z-index" style is to cancel z-index applied to other instances of subscriptionSchedulerModal-->
            <cv-subscription-scheduler
                [embedMode]="true"
                [reportType]="1"
                [triggerSave]="startSaving"
                [subscriptionId]="-1"
                [subscriptionTitle]="modalData.moduleName"
                [showInvalid]="isInvalid"
                [timezone]="modalData.timezone"
                (saved)="onSaved($event)"
                (saveFailed)="onSaveFailed()"
            ></cv-subscription-scheduler>
        </div>
    </div>
    <div class="buttons-holder d-flex justify-content-end pt-2 border-separator-top">
        <button [disabled]="isSaving" type="button" class="btn btn-text mr-2" (click)="onCancelClicked()" cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</button>
        <button [disabled]="isSaving" type="button" class="btn btn-primary" (click)="onSaveClicked()" cvLocalizedText [langSection]="'Common'" [langKey]="'Save_Button'">Save</button>
    </div>
</div>
